import { useLazyQuery, useMutation } from "@apollo/client";
import { 
    courseStatQuery, createInterviewResponse, createInterviewResponseBluePrint, createUserInterviewResponse, createUserInterviewResponseBluePrint, deleteInterviewResponse, deleteUserInterviewResponse, getCourseModuleResponseBluePrint, getCourseModulesResponseBluePrint, 
    getCourseResponseBluePrint, getCoursesResponseBluePrint, getInterviewResponse, getInterviewResponseBluePrint, getInterviewsResponse, getInterviewsResponseBluePrint, getQuestionAnswersResponseBluePrint, getQuestionsResponseBluePrint, getQuizResponseBluePrint, 
    getQuizzesResponseBluePrint, getScoreInterviewResponseBluePrint, getUserCourseResponseBluePrint, getUserCoursesResponseBluePrint, 
    getUserInterviewResponse, 
    getUserInterviewResponseBluePrint, 
    getUserInterviewsResponse, 
    getUserInterviewsResponseBluePrint, 
    getUserQuestionAnswersResponseBluePrint, 
    getUserQuizResponseBluePrint, 
    getUserQuizzesResponseBluePrint, 
    IAddCourseModulesRequest, 
    IAddCourseModulesResponse, 
    IAddLessonsRequest, 
    IAddLessonsResponse, 
    ICreateCourseRequest, ICreateCourseResponse, ICreateCourseResponseBluePrint, ICreateInterviewRequest, ICreateInterviewResponse, ICreateInterviewResponseBluePrint, ICreateQuizRequest, 
    ICreateQuizResponse, ICreateQuizResponseBluePrint, ICreateUserCourseRequest, ICreateUserCourseResponse, 
    ICreateUserCourseResponseBluePrint, ICreateUserInterviewRequest, ICreateUserInterviewResponse, ICreateUserInterviewResponseBluePrint, IDeleteCourseModuleRequest, IDeleteCourseModuleResponse, IDeleteCourseRequest, IDeleteCourseResponse, 
    IDeleteInterviewRequest, 
    IDeleteInterviewResponse, 
    IDeleteQuestionOptionRequest, 
    IDeleteQuestionOptionResponse, 
    IDeleteQuestionsByQuizIdRequest, IDeleteQuestionsByQuizIdResponse, IDeleteQuizAndGetQuizYearsRequest, 
    IDeleteQuizAndGetQuizYearsResponse, IDeleteQuizAndGetQuizYearsResponseBluePrint, IDeleteUserInterviewRequest, IDeleteUserInterviewResponse, IGetCourseModuleCountRequest, IGetCourseModuleCountResponse, IGetCourseModuleRequest, 
    IGetCourseModuleResponse, IGetCourseModuleResponseBluePrint, IGetCourseModulesRequest, 
    IGetCourseModulesResponse, IGetCourseModulesResponseBluePrint, IGetCourseRequest, IGetCourseResponse, 
    IGetCourseResponseBluePrint, IGetCoursesRequest, IGetCoursesResponse, IGetCoursesResponseBluePrint, 
    IGetCourseStatResponse, IGetCourseStatResponseBluePrint, IGetInterviewRequest, IGetInterviewResponse, IGetInterviewResponseBluePrint, IGetInterviewsRequest, IGetInterviewsResponse, IGetInterviewsResponseBluePrint, IGetQuestionAnswersRequest, IGetQuestionAnswersResponse, IGetQuestionAnswersResponseBluePrint, IGetQuestionsRequest, IGetQuestionsResponse, IGetQuestionsResponseBluePrint, IGetQuizRequest, IGetQuizResponse, 
    IGetQuizResponseBluePrint, IGetQuizYearsRequest, IGetQuizYearsResponse, IGetQuizYearsResponseBluePrint, 
    IGetQuizzesRequest, IGetQuizzesResponse, IGetQuizzesResponseBluePrint, IGetRecommendedCoursesRequest, 
    IGetRecommendedCoursesResponse, IGetRecommendedCoursesResponseBluePrint, IGetUserCourseRequest, 
    IGetUserCourseResponse, IGetUserCourseResponseBluePrint, IGetUserCoursesRequest, IGetUserCoursesResponse, 
    IGetUserCoursesResponseBluePrint, IGetUserInterviewRequest, IGetUserInterviewResponse, IGetUserInterviewResponseBluePrint, IGetUserInterviewsRequest, IGetUserInterviewsResponse, IGetUserInterviewsResponseBluePrint, IGetUserQuestionAnswersRequest, IGetUserQuestionAnswersResponse, IGetUserQuestionAnswersResponseBluePrint, IGetUserQuizzesRequest, IGetUserQuizzesResponse, 
    IGetUserQuizzesResponseBluePrint, IScoreInterviewRequest, IScoreInterviewResponse, IScoreInterviewResponseBluePrint, IScoreQuizRequest, IScoreQuizResponse, IScoreQuizResponseBluePrint, IUpdateCourseModulesRequest, IUpdateCourseModulesResponse, IUpdateCourseRequest, IUpdateCourseResponse, 
    IUpdateCourseResponseBluePrint, IUpdateInterviewRequest, IUpdateInterviewResponse, IUpdateInterviewResponseBluePrint, IUpdateInterviewUnifiedRequest, IUpdateInterviewUnifiedResponse, IUpdateInterviewUnifiedResponseBluePrint, IUpdateLessonsRequest, IUpdateLessonsResponse, IUpdateQuizUnifiedRequest, IUpdateQuizUnifiedResponse, IUpdateQuizUnifiedResponseBluePrint, IUpdateUserCourseRequest, IUpdateUserCourseResponse, 
    IUpdateUserCourseResponseBluePrint, IUpdateUserInterviewRequest, IUpdateUserInterviewResponse, IUpdateUserInterviewResponseBluePrint, quizYearQuery, 
    updateInterviewResponse,
    updateInterviewResponseBluePrint,
    updateInterviewUnifiedResponseBluePrint,
    updateUserInterviewResponse,
    updateUserInterviewResponseBluePrint
} from "./types";
import { gqlQueryStringBuilder } from "utils";
import { schema } from "./schema";

export const useCourseService = () => {
    const [scoreInterview] = useMutation<{scoreInterview: IScoreInterviewResponse}, IScoreInterviewRequest>(
        schema.scoreInterview(
            gqlQueryStringBuilder<IScoreInterviewResponse, IScoreInterviewResponseBluePrint>(
                ["userInterview"], getScoreInterviewResponseBluePrint
            )
        )
    )
    const [deleteUserInterview] = useMutation<{deleteUserInterview: IDeleteUserInterviewResponse}, IDeleteUserInterviewRequest>(
        schema.deleteUserInterview(
            gqlQueryStringBuilder<IDeleteUserInterviewResponse>(
                deleteUserInterviewResponse
            )
        )
    )
    const [createUserInterview] = useMutation<{createUserInterview: ICreateUserInterviewResponse}, ICreateUserInterviewRequest>(
        schema.createUserInterview(
            gqlQueryStringBuilder<ICreateUserInterviewResponse, ICreateUserInterviewResponseBluePrint>(
                createUserInterviewResponse, createUserInterviewResponseBluePrint
            )
        )
    )
    const [updateUserInterview] = useMutation<{updateUserInterview: IUpdateUserInterviewResponse}, IUpdateUserInterviewRequest>(
        schema.updateUserInterview(
            gqlQueryStringBuilder<IUpdateUserInterviewResponse, IUpdateUserInterviewResponseBluePrint>(
                updateUserInterviewResponse, updateUserInterviewResponseBluePrint
            )
        )
    )
    const [getUserInterviews] = useLazyQuery<{getUserInterviews: IGetUserInterviewsResponse}, IGetUserInterviewsRequest>(
        schema.getUserInterviews(
            gqlQueryStringBuilder<IGetUserInterviewsResponse, IGetUserInterviewsResponseBluePrint>(
                getUserInterviewsResponse, getUserInterviewsResponseBluePrint
            )
        )
    )
    const [getUserInterview] = useLazyQuery<{getUserInterview: IGetUserInterviewResponse}, IGetUserInterviewRequest>(
        schema.getUserInterview(
            gqlQueryStringBuilder<IGetUserInterviewResponse, IGetUserInterviewResponseBluePrint>(
                getUserInterviewResponse, getUserInterviewResponseBluePrint
            )
        )
    )


    // interviews
    const [deleteInterview] = useMutation<{deleteInterview: IDeleteInterviewResponse}, IDeleteInterviewRequest>(
        schema.deleteInterview(
            gqlQueryStringBuilder<IDeleteInterviewResponse>(
                deleteInterviewResponse
            )
        )
    )
    const [createInterview] = useMutation<{createInterview: ICreateInterviewResponse}, ICreateInterviewRequest>(
        schema.createInterview(
            gqlQueryStringBuilder<ICreateInterviewResponse, ICreateInterviewResponseBluePrint>(
                createInterviewResponse, createInterviewResponseBluePrint
            )
        )
    )
    const [updateInterview] = useMutation<{updateInterview: IUpdateInterviewResponse}, IUpdateInterviewRequest>(
        schema.updateInterview(
            gqlQueryStringBuilder<IUpdateInterviewResponse, IUpdateInterviewResponseBluePrint>(
                updateInterviewResponse, updateInterviewResponseBluePrint
            )
        )
    )
    const [updateInterviewUnified] = useMutation<{updateInterviewUnified: IUpdateInterviewUnifiedResponse}, IUpdateInterviewUnifiedRequest>(
        schema.updateInterviewUnified(
            gqlQueryStringBuilder<IUpdateInterviewUnifiedResponse, IUpdateInterviewUnifiedResponseBluePrint>(
                ["interview"], updateInterviewUnifiedResponseBluePrint
            )
        )
    )
    
    const [getInterviews] = useLazyQuery<{getInterviews: IGetInterviewsResponse}, IGetInterviewsRequest>(
        schema.getInterviews(
            gqlQueryStringBuilder<IGetInterviewsResponse, IGetInterviewsResponseBluePrint>(
                getInterviewsResponse, getInterviewsResponseBluePrint
            )
        )
    )
    const [getInterview] = useLazyQuery<{getInterview: IGetInterviewResponse}, IGetInterviewRequest>(
        schema.getInterview(
            gqlQueryStringBuilder<IGetInterviewResponse, IGetInterviewResponseBluePrint>(
                getInterviewResponse, getInterviewResponseBluePrint
            )
        )
    )

    /// course stats
    const [getCourseStat] = useLazyQuery<{getCourseStat: IGetCourseStatResponse}>(
        schema.getCourseStat(
            gqlQueryStringBuilder<IGetCourseStatResponse, IGetCourseStatResponseBluePrint>(
                ["courseStat"], {
                    courseStat: courseStatQuery
                }
            )
        )
    )
    const [deleteQuestionOption] = useMutation<{deleteQuestionOption: IDeleteQuestionOptionResponse}, IDeleteQuestionOptionRequest>(
        schema.deleteQuestionOption(
            gqlQueryStringBuilder<IDeleteQuestionOptionResponse>(
                ["questionOptionId"]
            )
        )
    )
    const [getQuestions] = useLazyQuery<{getQuestions: IGetQuestionsResponse}, IGetQuestionsRequest>(
        schema.getQuestions(
            gqlQueryStringBuilder<IGetQuestionsResponse, IGetQuestionsResponseBluePrint>(
                ["questions"], getQuestionsResponseBluePrint
            )
        )
    )
    const [getQuestionAnswers] = useLazyQuery<{getQuestionAnswers: IGetQuestionAnswersResponse}, IGetQuestionAnswersRequest>(
        schema.getQuestionAnswers(
            gqlQueryStringBuilder<IGetQuestionAnswersResponse, IGetQuestionAnswersResponseBluePrint>(
                ["questionAnswers"], getQuestionAnswersResponseBluePrint
            )
        )
    )
    const [deleteQuestionsByQuizId] = useMutation<{deleteQuestionsByQuizId: IDeleteQuestionsByQuizIdResponse}, IDeleteQuestionsByQuizIdRequest>(
        schema.deleteQuestionsByQuizId(
            gqlQueryStringBuilder<IDeleteQuestionsByQuizIdResponse>(
                ["quizId"],
            )
        )
    )
    const [deleteCourse] = useMutation<{deleteCourse: IDeleteCourseResponse}, IDeleteCourseRequest>(
        schema.deleteCourse(
            gqlQueryStringBuilder<IDeleteCourseResponse>(
                ["courseId"],
            )
        )
    )
    const [getCourses] = useLazyQuery<{getCourses: IGetCoursesResponse}, IGetCoursesRequest>(
        schema.getCourses(
            gqlQueryStringBuilder<IGetCoursesResponse, IGetCoursesResponseBluePrint>(
                ["courses"], getCoursesResponseBluePrint
            )
        )
    )
    const [getCourse] = useLazyQuery<{getCourse: IGetCourseResponse}, IGetCourseRequest>(
        schema.getCourse(
            gqlQueryStringBuilder<IGetCourseResponse, IGetCourseResponseBluePrint>(
                ["course"], getCourseResponseBluePrint
            )
        )
    )
    const [getRecommendedCourses] = useLazyQuery<{getRecommendedCourses: IGetRecommendedCoursesResponse}, IGetRecommendedCoursesRequest>(
        schema.getRecommendedCourses(
            gqlQueryStringBuilder<IGetRecommendedCoursesResponse, IGetRecommendedCoursesResponseBluePrint>(
                ["courses"], getCoursesResponseBluePrint
            )
        )
    )
    const [createUserCourse] = useMutation<{createUserCourse: ICreateUserCourseResponse}, ICreateUserCourseRequest>(
        schema.createUserCourse(
            gqlQueryStringBuilder<ICreateUserCourseResponse, ICreateUserCourseResponseBluePrint>(
                ["userCourse"], getUserCourseResponseBluePrint
            )
        )
    )
    const [getUserCourse] = useLazyQuery<{getUserCourse: IGetUserCourseResponse}, IGetUserCourseRequest>(
        schema.getUserCourse(
            gqlQueryStringBuilder<IGetUserCourseResponse, IGetUserCourseResponseBluePrint>(
                ["userCourse"], getUserCourseResponseBluePrint
            )
        )
    )
    const [getUserCourses] = useLazyQuery<{getUserCourses: IGetUserCoursesResponse}, IGetUserCoursesRequest>(
        schema.getUserCourses(
            gqlQueryStringBuilder<IGetUserCoursesResponse, IGetUserCoursesResponseBluePrint>(
                ["userCourses"], getUserCoursesResponseBluePrint
            )
        )
    )
    const [addLessons] = useMutation<{addLessons: IAddLessonsResponse}, IAddLessonsRequest>(
        schema.addLessons(
            gqlQueryStringBuilder<IAddLessonsResponse>(
                ["lessonIds"],
            )
        )
    )
    const [updateLessons] = useMutation<{updateLessons: IUpdateLessonsResponse}, IUpdateLessonsRequest>(
        schema.updateLessons(
            gqlQueryStringBuilder<IUpdateLessonsResponse>(
                ["lessonIds"],
            )
        )
    )
    // Course modules
    const [getCourseModuleCount] = useLazyQuery<{getCourseModuleCount: IGetCourseModuleCountResponse}, IGetCourseModuleCountRequest>(
        schema.getCourseModuleCount(
            gqlQueryStringBuilder<IGetCourseModuleCountResponse>(
                ["moduleCount"]
            )
        )
    )
    const [addCourseModules] = useMutation<{addCourseModules: IAddCourseModulesResponse}, IAddCourseModulesRequest>(
        schema.addCourseModules(
            gqlQueryStringBuilder<IAddCourseModulesResponse>(
                ["courseModuleIds"],
            )
        )
    )
    const [updateCourseModules] = useMutation<{updateCourseModules: IUpdateCourseModulesResponse}, IUpdateCourseModulesRequest>(
        schema.updateCourseModules(
            gqlQueryStringBuilder<IUpdateCourseModulesResponse>(
                ["courseModuleIds"]
            )
        )
    )
    const [getCourseModules] = useLazyQuery<{getCourseModules: IGetCourseModulesResponse}, IGetCourseModulesRequest>(
        schema.getCourseModules(
            gqlQueryStringBuilder<IGetCourseModulesResponse, IGetCourseModulesResponseBluePrint>(
                ["courseModules"], getCourseModulesResponseBluePrint
            )
        )
    )
    const [getCourseModule] = useLazyQuery<{getCourseModule: IGetCourseModuleResponse}, IGetCourseModuleRequest>(
        schema.getCourseModule(
            gqlQueryStringBuilder<IGetCourseModuleResponse, IGetCourseModuleResponseBluePrint>(
                ["courseModule"], getCourseModuleResponseBluePrint
            )
        )
    )
    const [deleteCourseModule] = useMutation<{deleteCourseModule: IDeleteCourseModuleResponse}, IDeleteCourseModuleRequest>(
        schema.deleteCourseModule(
            gqlQueryStringBuilder<IDeleteCourseModuleResponse>(
                ["courseModuleId"],
            )
        )
    )
    const [scoreQuiz] = useMutation<{scoreQuiz: IScoreQuizResponse}, IScoreQuizRequest>(
        schema.scoreQuiz(
            gqlQueryStringBuilder<IScoreQuizResponse, IScoreQuizResponseBluePrint>(
                ["userQuiz"], getUserQuizResponseBluePrint
            )
        )
    )
    const [getUserQuizzes] = useLazyQuery<{getUserQuizzes: IGetUserQuizzesResponse}, IGetUserQuizzesRequest>(
        schema.getUserQuizzes(
            gqlQueryStringBuilder<IGetUserQuizzesResponse, IGetUserQuizzesResponseBluePrint>(
                ["userQuizzes"], getUserQuizzesResponseBluePrint
            )
        )
    )
    const [getUserQuestionAnswers] = useLazyQuery<{getUserQuestionAnswers: IGetUserQuestionAnswersResponse}, IGetUserQuestionAnswersRequest>(
        schema.getUserQuestionAnswers(
            gqlQueryStringBuilder<IGetUserQuestionAnswersResponse, IGetUserQuestionAnswersResponseBluePrint>(
                ["userQuestionAnswers"], getUserQuestionAnswersResponseBluePrint
            )
        )
    )
    const [getQuiz] = useLazyQuery<{getQuiz: IGetQuizResponse}, IGetQuizRequest>(
        schema.getQuiz(
            gqlQueryStringBuilder<IGetQuizResponse, IGetQuizResponseBluePrint>(
                ["quiz"], getQuizResponseBluePrint
            )
        )
    )
    const [updateQuizUnified] = useMutation<{updateQuizUnified: IUpdateQuizUnifiedResponse}, IUpdateQuizUnifiedRequest>(
        schema.updateQuizUnified(
            gqlQueryStringBuilder<IUpdateQuizUnifiedResponse, IUpdateQuizUnifiedResponseBluePrint>(
                ["quiz"], getQuizResponseBluePrint
            )
        )
    )
    const [createQuiz] = useMutation<{createQuiz: ICreateQuizResponse}, ICreateQuizRequest>(
        schema.createQuiz(
            gqlQueryStringBuilder<ICreateQuizResponse, ICreateQuizResponseBluePrint>(
                ["quiz"], getQuizResponseBluePrint
            )
        )
    )
    const [getQuizzes] = useLazyQuery<{getQuizzes: IGetQuizzesResponse}, IGetQuizzesRequest>(
        schema.getQuizzes(
            gqlQueryStringBuilder<IGetQuizzesResponse, IGetQuizzesResponseBluePrint>(
                ["quizzes"], getQuizzesResponseBluePrint
            )
        )
    )
    const [getQuizYears] = useLazyQuery<{getQuizYears: IGetQuizYearsResponse}, IGetQuizYearsRequest>(
        schema.getQuizYears(
            gqlQueryStringBuilder<IGetQuizYearsResponse, IGetQuizYearsResponseBluePrint>(
                ["quizYears"], {
                    quizYears: quizYearQuery
                }
            )
        )
    )
    const [updateUserCourse] = useMutation<{updateUserCourse: IUpdateUserCourseResponse}, IUpdateUserCourseRequest>(
        schema.updateUserCourse(
            gqlQueryStringBuilder<IUpdateUserCourseResponse, IUpdateUserCourseResponseBluePrint>(
                ["userCourse"], getUserCourseResponseBluePrint
            )
        )
    )
    const [deleteQuizAndGetQuizYears] = useMutation<{deleteQuizAndGetQuizYears: IDeleteQuizAndGetQuizYearsResponse}, IDeleteQuizAndGetQuizYearsRequest>(
        schema.deleteQuizAndGetQuizYears(
            gqlQueryStringBuilder<IDeleteQuizAndGetQuizYearsResponse, IDeleteQuizAndGetQuizYearsResponseBluePrint>(
                ["quizYears"], {
                    quizYears: quizYearQuery
                }
            )
        )
    )
    const [updateCourse] = useMutation<{updateCourse: IUpdateCourseResponse}, IUpdateCourseRequest>(
        schema.updateCourse(
            gqlQueryStringBuilder<IUpdateCourseResponse, IUpdateCourseResponseBluePrint>(
                ["course"], getCourseResponseBluePrint
            )
        )
    )
    const [createCourse] = useMutation<{createCourse: ICreateCourseResponse}, ICreateCourseRequest>(
        schema.createCourse(
            gqlQueryStringBuilder<ICreateCourseResponse, ICreateCourseResponseBluePrint>(
                ["course"], getCourseResponseBluePrint
            )
        )
    )
    
    return {
        scoreInterview,

        getUserInterview,
        getUserInterviews,
        updateUserInterview,
        deleteUserInterview,
        createUserInterview,

        getInterview,
        getInterviews,
        updateInterview,
        updateInterviewUnified,
        deleteInterview,
        createInterview,

        createCourse,
        updateCourse,
        deleteQuizAndGetQuizYears,
        updateUserCourse,
        getQuizzes,
        getQuizYears,
        createQuiz,
        getQuiz,
        updateQuizUnified,
        scoreQuiz,
        getUserQuizzes,
        updateLessons,
        addLessons,

        getCourseModuleCount,
        addCourseModules,
        updateCourseModules,
        getCourseModules,
        getCourseModule,
        deleteCourseModule,

        
        createUserCourse,
        getUserCourse,
        getUserCourses,
        getUserQuestionAnswers,
        getRecommendedCourses,
        getCourse,
        getCourses,
        deleteCourse,
        getQuestionAnswers,
        deleteQuestionsByQuizId,
        deleteQuestionOption,
        getQuestions,
        getCourseStat
    };
};